﻿/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class appointmentindex extends IceEntity {
    appointment_index_key: string = "";
    appointment_key: string = "";
    patient_trans_account: string = "";
    trans_account: string = "";
    account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    appointment_status: IceTypes.appt_status = IceTypes.appt_status.apptstatNone;
    appointment_type: IceTypes.appt_type = IceTypes.appt_type.appttypeOther;
    time_slot_start: any = NaN;
    time_slot_end: any = NaN;
    interval_type: IceTypes.interval.interval15 = IceTypes.interval.interval15;
    subject: string = "";
    last_name: string = "";
    phone: string = "";
    provider_keywords: string = "";
    slot_color: string = "";
    slot_font_color: string = "";

    gettablename(): string {
        return "APPOINTMENT_INDEX";
    }
}
